import CardCommon from '@/pages/opinion/components/CardCommon';
import { gameInfoType } from '@/pages/opinion/types/common';
import { keyMetricsType } from '@/pages/opinion/types/performance';
import MetricsCard from '@/pages/opinion/widgets/metrics/MetricsCard';
import { getKolBrandKeyMetrics } from '@op/services/influencer';
import { dealwithMetricsData } from '@op/widgets/metrics/hooks';
import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { keyMetricsMap } from '../../constants';
import './index.scss';

export default function KeyMetrics({
  gameInfo,
  filter,
  mediaType,
}: {
  gameInfo: gameInfoType;
  filter: any;
  mediaType: string;
}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ key_metrics: [], time_period: {} });
  const { formatMessage } = useIntl();

  const tabMap = useMemo(() => {
    const currentKeyMetricsMap = keyMetricsMap[mediaType] || {};
    return Object.keys(currentKeyMetricsMap).reduce((pre, cur) => {
      const item = currentKeyMetricsMap?.[cur] || {};
      return {
        ...pre,
        [item.key || cur]: {
          ...item,
          title: formatMessage({ id: item.title }),
        },
      };
    }, {});
  }, [mediaType, formatMessage]);

  useEffect(() => {
    setLoading(true);
    const list = keyMetricsMap?.[mediaType] || {};
    getKolBrandKeyMetrics({
      ...filter,
      metrics: Object.keys(list),
    })
      .then((data: any) => {
        const sortMap = Object.keys(list).reduce((pre, cur) => {
          return { ...pre, [list[cur].key || cur]: list[cur].sort };
        }, {});

        const result = dealwithMetricsData(data, sortMap, {
          key: 'name',
          value: 'value',
        });
        setData(result);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, mediaType]);

  return (
    <CardCommon
      className="influencer-key-metrics-wrapper"
      title={formatMessage({ id: 'Key Metrics' })}
      loading={loading}
      contentCard
      hasEmptyImg={false}
      empty={data?.key_metrics?.length === 0}
      hasEmptyDesc={false}
      loadingHeight={140}
      emptyHeight={140}
    >
      <div className={`dbo-key-metrics box-${data?.key_metrics?.length}`}>
        {data?.key_metrics?.map?.((item: keyMetricsType, index: number) => {
          return (
            <div key={item.metric_name} className="key-metric-item">
              <MetricsCard
                time_period={data?.time_period || {}}
                data={item}
                gameInfo={gameInfo}
                filter={filter}
                titleMap={tabMap}
                isLast={index + 1 === data?.key_metrics.length}
              />
            </div>
          );
        })}
      </div>
    </CardCommon>
  );
}
